import {EventEmitter, Inject, Injectable} from "@angular/core";
import {NgbModal, NgbModalConfig, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {Observable} from "rxjs"
import {HttpClient} from "@angular/common/http";
import {ToastService} from "../toast/toast.service";
import * as PubSub from 'pubsub-js'
import {PubsubEnum} from "../../enums/pubsub.enum";
import {
  TokenCancelAuthorizationComponent
} from "../../../components/token-cancel-authorization/token-cancel-authorization.component";
import {environment} from "../../../../environments/environment";

@Injectable({providedIn: "root"})
export class TokenCancelAuthorizationService {

  private modalRef!: NgbModalRef;
  private baseEndpoint: string;
  public tokenBlockError: boolean = false;
  public showContactGacModal: boolean = false;
  public closeModalTokenUnlock: EventEmitter<void> = new EventEmitter<void>();


  constructor(
    private modalService: NgbModal,
    private http: HttpClient,
    private modalConfig: NgbModalConfig,
    private toastService: ToastService,
  ) {
    this.baseEndpoint = environment.apiUser
    modalConfig.backdrop = 'static';
    modalConfig.keyboard = true;
  }

  open() {
    this.configModal();
  }

  getRef() {
    return this.modalRef;
  }

  configModal() {
    this.modalRef = this.modalService.open(TokenCancelAuthorizationComponent);
  }

  close() {
    PubSub.publish(PubsubEnum.CLOSE_UNLOCKTOKEN_MODAL);
    // this.closeModalTokenUnlock.emit();
    if (this.modalRef) {
      this.modalRef.close();
    }
  }

  closeWithRef(modalRef: any) {
    if (modalRef) {
      this.modalRef.close();
    }
  }

  validateCode(code: string): Observable<any> {
    return this.http.post<any>(`${this.baseEndpoint}/token/unlock`, {
      code
    })
  }
}
